import React, { useState } from 'react';
import { Button, Icon } from '@kajabi/sage-react';

import { useFormikContext } from 'formik';
import { useUiResourceContext } from 'common/components/CopyMagic/contexts';
import { CHAT_EVENT_TYPES } from 'common/components/CopyMagic/constants';
import { useMessagesContext } from 'common/components/CopyMagic/contexts/MessagesContext';
import useChatSessionId from 'common/components/CopyMagic/hooks/useChatSessionId';
import postChatEvent from 'common/components/CopyMagic/api/postChatEvent';

import RestartConfirmationModal from '../RestartConfirmationModal';

const RestartButton = () => {
  const [restartModalActive, setRestartModalActive] = useState(false);
  const { loading, resetError, resetPromptValues } = useUiResourceContext();
  const { resetMessages } = useMessagesContext();
  const { resetForm } = useFormikContext();
  const { getChatSessionId } = useChatSessionId();

  const restartChat = () => {
    resetMessages();
    resetError();
    resetPromptValues();
    resetForm({
      errors: { topic: "can't be blank" },
    });
    setRestartModalActive(false);
    postChatEvent({ sessionId: getChatSessionId(), eventType: CHAT_EVENT_TYPES.RESTARTED });
  };

  const handleClick = () => {
    setRestartModalActive(true);
  };

  const handleCancel = () => {
    setRestartModalActive(false);
  };

  return (
    <>
      <RestartConfirmationModal
        active={restartModalActive}
        onConfirm={restartChat}
        onCancel={handleCancel}
      />
      <Button
        color={Button.COLORS.SECONDARY}
        icon={Icon.ICONS.SYNC}
        onClick={handleClick}
        disabled={!!loading}
        iconOnly
        subtle
      >
        Restart Chat
      </Button>
    </>
  );
};

export default RestartButton;
